import React from 'react';
import styles from './ui-card.module.scss';

interface UICardProps {
    children: React.ReactNode;
    className?: string;
    hover?: boolean;
    onClick?: () => void;
}

export function UICard({ children, className = '', hover = false, onClick }: UICardProps) {
    const classes = [
        styles.card,
        hover ? styles.hover : '',
        className,
    ].filter(Boolean).join(' ');

    return <div className={classes} onClick={onClick}>{children}</div>;
}

export default UICard;
